'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var Image_module = require('./Image.module-e3b7ba64.js');
require('./index-72f7f45d.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function LazyImage(_ref) {
  var extraClass = _ref.extraClass,
    alt = _ref.alt,
    title = _ref.title,
    height = _ref.height,
    width = _ref.width,
    maxWidth = _ref.maxWidth,
    id = _ref.id,
    src = _ref.src;
    _ref.defaultImg;
    _ref.onError;
    var roundCornerAll = _ref.roundCornerAll,
    maskImageSrc = _ref.maskImageSrc,
    _ref$maskRepeat = _ref.maskRepeat,
    maskRepeat = _ref$maskRepeat === void 0 ? "no-repeat" : _ref$maskRepeat,
    _ref$maskSize = _ref.maskSize,
    maskSize = _ref$maskSize === void 0 ? "100% 100%" : _ref$maskSize,
    _ref$maskPosition = _ref.maskPosition,
    maskPosition = _ref$maskPosition === void 0 ? "center center" : _ref$maskPosition,
    aspectRatio = _ref.aspectRatio,
    _ref$objectFit = _ref.objectFit,
    objectFit = _ref$objectFit === void 0 ? aspectRatio || height ? "cover" : null : _ref$objectFit,
    objectPosition = _ref.objectPosition,
    style = _ref.style,
    block = _ref.block,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? "lazy" : _ref$loading;
  return /*#__PURE__*/React__default["default"].createElement("img", {
    className: [extraClass, roundCornerAll == "radiusXXS" ? Image_module.modules_6f921488.radiusXXS : roundCornerAll == "radiusXS" ? Image_module.modules_6f921488.radiusXS : roundCornerAll == "radiusS" ? Image_module.modules_6f921488.radiusS : roundCornerAll == "radiusBase" ? Image_module.modules_6f921488.radiusBase : roundCornerAll == "radiusM" ? Image_module.modules_6f921488.radiusM : roundCornerAll == "radiusL" ? Image_module.modules_6f921488.radiusL : roundCornerAll == "radiusXL" ? Image_module.modules_6f921488.radiusXL : roundCornerAll == "radiusCircle" ? Image_module.modules_6f921488.radiusCircle : null, objectFit == "cover" ? Image_module.modules_6f921488.objectFitCover : objectFit == "fill" ? Image_module.modules_6f921488.objectFitFill : objectFit == "contain" ? Image_module.modules_6f921488.objectFitContain : objectFit == "scale-down" ? Image_module.modules_6f921488.objectFitScaleDown : null, objectPosition == "center" ? Image_module.modules_6f921488.objectPositionCenter : objectPosition == "center top" ? Image_module.modules_6f921488.objectPositionCenterTop : objectPosition == "center Bottom" ? Image_module.modules_6f921488.objectPositionCenterBottom : objectPosition == "left center" ? Image_module.modules_6f921488.objectPositionLeftCenter : objectPosition == "left top" ? Image_module.modules_6f921488.objectPositionLeftTop : objectPosition == "left bottom" ? Image_module.modules_6f921488.objectPositionLeftBottom : objectPosition == "right center" ? Image_module.modules_6f921488.objectPositionRightCenter : objectPosition == "right top" ? Image_module.modules_6f921488.objectPositionRightTop : objectPosition == "right bottom" ? Image_module.modules_6f921488.objectPositionRightBottom : null, aspectRatio == "4 / 3" ? Image_module.modules_6f921488.aspectRatio4_3 : aspectRatio == "3 / 4" ? Image_module.modules_6f921488.aspectRatio3_4 : aspectRatio == "16 / 9" ? Image_module.modules_6f921488.aspectRatio16_9 : aspectRatio == "9 / 16" ? Image_module.modules_6f921488.aspectRatio9_16 : aspectRatio == "1 / 1" ? Image_module.modules_6f921488.aspectRatio1_1 : null, style == "Shadow" ? Image_module.modules_6f921488.Shadow : null].join(" "),
    alt: alt,
    title: title,
    id: id,
    src: src,
    style: {
      WebkitMaskImage: maskImageSrc ? "url(" + maskImageSrc + ")" : null,
      maskImage: maskImageSrc ? "url(" + maskImageSrc + ")" : null,
      WebkitMaskRepeat: maskImageSrc ? "" + maskRepeat + "" : null,
      maskRepeat: maskImageSrc ? "" + maskRepeat + "" : null,
      WebkitMaskSize: maskImageSrc ? "" + maskSize + "" : null,
      maskSize: maskImageSrc ? "" + maskSize + "" : null,
      WebkitMaskPosition: maskImageSrc ? "" + maskPosition + "" : null,
      maskPosition: maskImageSrc ? "" + maskPosition + "" : null,
      maxWidth: maxWidth ? "" + maxWidth + "" : null,
      width: width ? "" + width + "" : null,
      height: height ? "" + height + "" : null,
      display: block ? "block" : null
    },
    loading: loading
  });
}
var radiusOptions = ["radiusXXS", "radiusXS", "radiusS", "radiusBase", "radiusM", "radiusL", "radiusXL", "radiusCircle"];
var objectFitOptions = ["none", "cover", "fill", "contain", "scale-down"];
var objectPositionOptions = ["none", "center", "center top", "center bottom", "left center", "left top", "left bottom", "right center", "right top", "right bottom"];
var aspectRatioOptions = ["auto", "4 / 3", "3 / 4", "16 / 9", "9 / 16", "1 / 1"];
LazyImage.propTypes = {
  extraClass: index.propTypes.exports.string,
  alt: index.propTypes.exports.string,
  id: index.propTypes.exports.string,
  title: index.propTypes.exports.string,
  height: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  width: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  maxWidth: index.propTypes.exports.oneOfType([index.propTypes.exports.string, index.propTypes.exports.number]),
  src: index.propTypes.exports.string,
  defaultImg: index.propTypes.exports.string,
  roundCornerAll: index.propTypes.exports.oneOf(radiusOptions),
  objectFit: index.propTypes.exports.oneOf(objectFitOptions),
  objectPosition: index.propTypes.exports.oneOf(objectPositionOptions),
  maskImageSrc: index.propTypes.exports.string,
  maskRepeat: index.propTypes.exports.string,
  maskSize: index.propTypes.exports.string,
  maskPosition: index.propTypes.exports.oneOf(objectPositionOptions),
  aspectRatio: index.propTypes.exports.oneOf(aspectRatioOptions),
  style: index.propTypes.exports.oneOf(["Flat", "Shadow"]),
  loading: index.propTypes.exports.oneOf(["lazy", "eager"]),
  block: index.propTypes.exports.bool
};

exports.LazyImage = LazyImage;
